var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inner-page"},[_c('navBar',[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.pageTitle))])]),_c('div',{staticClass:"page-content"},[_c('iframe',{staticClass:"web-view",attrs:{"src":_vm.webUrl,"frameborder":"0"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }